import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http";
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { User, Register, Login, Office, Search } from './user.model';

@Injectable()
export class UserService {
    //readonly rootUrl = 'http://localhost:14049';
   readonly rootUrl = 'http://dcreapi.esdinfra.com';
  httpOptions: any;

  constructor(private http: HttpClient) {
    let accesstoken = localStorage.getItem('accessToken');
    if (accesstoken != null && accesstoken != '' && typeof (accesstoken) != undefined) {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + accesstoken,
          'No-Auth': 'True'
        })
      };
    }
  }

  getAllowedPages() {
    let accesstoken = localStorage.getItem('accessToken');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accesstoken
      })
    };
    return this.http.get(this.rootUrl + '/api/AllowedPages', this.httpOptions);
  }

  getAllRoles(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  getAllUsers(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }
  getAllClaimsForTheRole(roleId: string) {
    return this.http.get(this.rootUrl + '/api/Claims/' + roleId, this.httpOptions);
  }
  getRoleForTheId(roleId: string) {
    return this.http.get(this.rootUrl + '/api/Roles/' + roleId, this.httpOptions);
  }

  getUserForTheId(Id: string) {
    return this.http.get(this.rootUrl + '/api/Users/' + Id, this.httpOptions);
  }
  
  getOfficeForTheId(OfficeId: string) {
       return this.http.get(this.rootUrl + '/api/Offices/' + OfficeId, this.httpOptions);
  }

  getAllClaims(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  GetAllRoleNames() {
    return this.http.get(this.rootUrl + '/api/Roles/GetAllOffices/', this.httpOptions);
  }

  getAllDistrictName() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Users/GetAllDistrict', this.httpOptions);
  }

  getRolesforSelectedOffice(officeId) {
    return this.http.get(this.rootUrl + '/api/Roles/getRolesforSelectedOffice/' + officeId, this.httpOptions);
  }

  GetAllOffices(itemsPerPage:number,pageNo:number) {
    return this.http.get(this.rootUrl + '/api/Offices/GetAll/' +itemsPerPage+"/"+pageNo, this.httpOptions);
  }


  registerUser(register: Register) {
  
    return this.http.post(this.rootUrl + '/api/Account/Register', register, this.httpOptions);
  }

  registerCustomer(register: Register) {
  
    return this.http.post(this.rootUrl + '/api/CustomerAccount/Register', register, this.httpOptions);
  }

  createRole(user: User) {
    return this.http.post(this.rootUrl + '/api/Roles/Create', user, this.httpOptions);
  }

  updateRole(user: User,roleId:string) {
    return this.http.put(this.rootUrl + '/api/Roles/Update/'+roleId, user, this.httpOptions);
  }

  searchRoles(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  

  searchUsers(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  

  searchOffices(searchCriteria:any,searchText:any, itemsPerPage:number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Offices/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  
  updateOffice(office: Office,OfficeId:string) {
       return this.http.put(this.rootUrl + '/api/Offices/Update/'+OfficeId, office, this.httpOptions);
  }

  saveClaims(claimsList, roleId) {
    return this.http.put(this.rootUrl + '/api/Claims/' + roleId + '/assignClaims', claimsList, this.httpOptions);
  }

  CreateOffice(office: Office) {
    return this.http.post(this.rootUrl + '/api/Offices/Create', office, this.httpOptions);
  }

  changePassword(userDetails:any){
    return this.http.post(this.rootUrl + '/api/Account/ChangePassword', userDetails, this.httpOptions);
  }
  
  changePasswordForTheId(userDetails:any){
    return this.http.put(this.rootUrl + '/api/Account/Update', userDetails, this.httpOptions);
  }

  deleteRole(id: string){
    return this.http.put(this.rootUrl + '/api/Roles/Delete/'+id, this.httpOptions);
  }

  activateInactivateUser(id: string){
    return this.http.put(this.rootUrl + '/api/Users/ActivateInactivate/'+id, null, this.httpOptions);
  }
  
  activateInactivateRoles(id: string){
    return this.http.put(this.rootUrl + '/api/Roles/ActivateInactivate/'+id, null, this.httpOptions);
  }

  activateInactivateOffices(id: string){
    return this.http.put(this.rootUrl + '/api/Offices/ActivateInactivate/'+id, null, this.httpOptions);
  }

  userAuthentication(user: Login) {
    var data = "username=" + user.UserName + "&password=" + user.Password + "&grant_type=password";
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' })
    }
    return this.http.post(this.rootUrl + '/token', data, httpOptions);
  }
  

}



// WEBPACK FOOTER //
// ./src/app/shared/user.service.ts